import type * as amplitude from '@amplitude/analytics-browser';

import {
  type ContinueClickedProperties,
  type Ampli as GeneratedBrowserAmpli,
  type Environment as GeneratedBrowserEnvironment,
  type LoadOptions as GeneratedBrowserLoadOptions,
  type ListEnrichmentFileRejectedProperties,
  ampli as generatedBrowserAmpli,
} from '../ampli-browser/generated/index.js';
import {
  type LoadOptionsWithRequiredServerUrl,
  type LoadableAmpli,
  ManagedAmpliClient,
  type ManagedAmpliOptions,
  assertLoadOptionsServerUrl,
} from './shared.js';

export type {
  ContinueClickedProperties,
  GeneratedBrowserAmpli as BrowserAmpliClient,
  ListEnrichmentFileRejectedProperties,
};
export { generatedBrowserAmpli as ampli };

type BrowserClient = amplitude.Types.BrowserClient;
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserLoadOptions = LoadOptionsWithRequiredServerUrl<
  BrowserClient,
  BrowserOptions,
  GeneratedBrowserEnvironment
>;

export type BrowserAmpli<TLoadOptions> = LoadableAmpli<TLoadOptions>;

export type BrowserAmpliOptions<
  TLoadOptions,
  TAmpli extends BrowserAmpli<TLoadOptions>,
> = ManagedAmpliOptions<TLoadOptions, TAmpli>;

export type BrowserAnalytics<
  TLoadOptions,
  TAmpli extends BrowserAmpli<TLoadOptions>,
> = ManagedAmpliClient<TLoadOptions, TAmpli>;

export function createBrowserAmpli<TLoadOptions, TAmpli extends BrowserAmpli<TLoadOptions>>(
  options: BrowserAmpliOptions<TLoadOptions, TAmpli>,
): BrowserAnalytics<TLoadOptions, TAmpli> {
  return new ManagedAmpliClient(options);
}

export function loadBrowserAmpli(options: BrowserLoadOptions): GeneratedBrowserAmpli {
  assertLoadOptionsServerUrl(options, 'browser');
  generatedBrowserAmpli.load(options as GeneratedBrowserLoadOptions);
  return generatedBrowserAmpli;
}
